import { render, staticRenderFns } from "./GroupAddContacts.vue?vue&type=template&id=58846a66&"
import script from "./GroupAddContacts.vue?vue&type=script&lang=js&"
export * from "./GroupAddContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports